import { httpBackOfficeUtil } from "./httpBackOfficeUtil"
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil"

export const subscriptions = {
    getContactSubscriptions,
    getContactServices,
    addSubscriptionDevices,
    enableDevices,
    getSubscriptionDevices,
    getDevice,
    updateDevice,
    updateSubscriptionDevice,
    getSubscriptionAction,
    getServiceDevices,
    activateSubscription,
    addSubscriptionService: addSubscriptionService,
    getDeviceById: getDeviceById,
    activateService: activateService,
    updateService: updateService,
    loadInstallerDevices: loadInstallerDevices
}


async function getContactSubscriptions(contactId) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/contacts/' + contactId + '/subscriptions',
            queryParams: {
                include_terms: true
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getContactSubscriptions: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}



async function getContactServices({
    contact_id,
    subscription_id
} = {}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/contacts/' + contact_id + '/services',
            queryParams: {
                subscription_id: subscription_id
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getContactServices: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function addSubscriptionDevices({
    device_id,
    subscription_id
}) {
    try {
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/subscriptions/' + subscription_id + '/devices',
            withAccessToken: true,
            body: {
                device_id
            },
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("AAAA addSubscriptionDevices: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function enableDevices({
    devices,
    service_id,
}) {
    try {
        let body = [];
        for (let i = 0; i < devices.length; i++) {
            body.push({
                action: "ENABLE",
                device_id: devices[i].device_id
            })
        }
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/services/' + service_id + '/devices',
            withAccessToken: true,
            body: body
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("AAAA enableDevices: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function getSubscriptionDevices({
    subscription_id,
    search_value
} = {}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/subscriptions/' + subscription_id + '/devices',
            queryParams: {
                subscription_id: subscription_id,
                search_value
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getSubscriptionDevices: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function loadInstallerDevices({
    organisation_id,
    installerId
})
{
    let devices = [];
    let maxFetch = 100;
    try {
        let page = 1;
        while (page <= maxFetch) {
            const result = await getDevice({
                owner_id: organisation_id,
                include_custom_fields: true,
                custom_fields: `contractor;${installerId}`,
                include_subscription: false,
                size: 100,
                page: page
            });
            console.log('device on contact - page ' + page, result);
            if (result.code == "OK" && result.data && result.data.content && result.data.content.length > 0) {
                devices = devices.concat(result.data.content);
            }else {
                return devices;
            }
            console.log('devices loaded ' + devices.length);
            if (result.data.paging.has_more === false || result.data.paging.size < 100){
                console.log('total devices loaded ' + devices.length);
                return devices;
            }
                
            page++;
        }
    } catch (ex) {
        console.log("loadInstallerDevices Exception: ", ex);
    }
    return devices;
}




async function getDevice({
    contact_id,
    owner_id,
    serial_number,
    include_subscription = true,
    subscription_ids,
    include_custom_fields = true,
    custom_fields,
    in_warehouse = true,
    size = 100,
    page = 1
}={}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/devices',
            queryParams: {
                contact_id,
                serial_number,
                include_subscription,
                subscription_ids,
                include_custom_fields,
                custom_fields,
                in_warehouse,
                owner_id,
                size,
                page
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getDevice: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateDevice({ custom_fields } = {}, deviceId) {
    try {
        let response = await httpBackOfficeUtil.put({
            resourcePath: `/v2/devices/${deviceId}`,
            body: {
                custom_fields
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateDevice: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateSubscriptionDevice({ action, replaced_by_device_id } = {}, subId, deviceId) {
    try {
        let response = await httpBackOfficeUtil.put({
            resourcePath: `/v2/subscriptions/${subId}/devices/${deviceId}`,
            body: {
                action,
                replaced_by_device_id,
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateSubscriptionDevice: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getSubscriptionAction({
    action_id,
}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/subscriptions/actions/' + action_id,
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getSubscriptionAction: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getServiceDevices({
    service_id
} = {}) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/services/' + service_id + '/devices',
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getServiceDevices: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function activateSubscription({
    subscription_id
}) {
    try {
        let response = await httpBackOfficeUtil.put({
            resourcePath: '/v2/subscriptions/' + subscription_id,
            withAccessToken: true,
            body: {
                action: 'ACTIVATE'
            },
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("activateSubscription Exception: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function addSubscriptionService({
    subscription_id,
    reqBody
}) {
    try {
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/subscriptions/' + subscription_id + '/services',
            withAccessToken: true,
            body: reqBody
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("addSubscriptionService Exception: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function getDeviceById(deviceId) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: `/v2/devices/${deviceId}`,
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("getDeviceById Exception: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function activateService(serviceId) {
    try {
        let response = await httpBackOfficeUtil.put({
            resourcePath: `/v2/services/${serviceId}`,
            body: {
                action: 'ACTIVATE'
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateDevice: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateService({ action, quantity } = {}, serviceId) {
    try {
        let response = await httpBackOfficeUtil.put({
            resourcePath: `/v2/services/${serviceId}`,
            body: {
                action,
                quantity,
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateService: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}